import React from 'react'
import { Routes, Route } from 'react-router-dom'

import PersonsIndex from './persons_index.jsx'
import PersonsNew from './persons_new.jsx'
import PersonsEdit from './persons_edit.jsx'

let PersonsRouter = () => (
  <Routes>
    <Route exact path="/"          element={ <PersonsIndex /> } />
    <Route exact path="/new"      element={ <PersonsNew /> } />
    <Route       path="/:id/edit" element={ <PersonsEdit /> } />
  </Routes>
)

export default PersonsRouter
